import { GET_HOME_CAROUSELS, GET_LAYOUT, GET_RECOMMEND, GET_STATIC_PATHS } from '../actions/layout/type'

const initState = { layouts: {}, recommend_contents: [], home_banners: [], paths: [] }
export default function (state = initState, action) {
    switch (action.type) {
        case GET_LAYOUT:
            const newLayouts = JSON.parse(JSON.stringify(state.layouts))
            if (action.payload && action.payload.length > 0) {
                newLayouts[action.page] = action.payload
            } else if (!newLayouts[action.page]) {
                newLayouts[action.page] = []
            }
            return { ...state, layouts: newLayouts }
        case GET_RECOMMEND:
            return { ...state, recommend_contents: action.payload }
        case GET_HOME_CAROUSELS:
            return { ...state, home_banners: action.payload }
        case GET_STATIC_PATHS:
            return { ...state, paths: action.payload }
        default:
            return state
    }
}